module.exports = __webpack_public_path__ + "img/R.a209287c.png";